import { inject } from '@angular/core';
import { AuthSessionService } from '../../../core/auth/auth-session.service';

export function hasSession(): boolean {
  return !!inject(AuthSessionService).user();
}
